<!--
component: ListElvAddress
author: Ken Nakamura
description: 昇降機住所検索結果リスト
-->
<template>
  <section>
    <v-data-table
      :headers="headers" :items="kenkaku"
      :fixed-header="false" height="calc(100vh - 20em)"
      mobile-breakpoint="0"
      disable-pagination hide-default-footer dense
      :single-select="true" item-key="daichoId"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="(item, index) in items"
            @click="selectRow(item)"
            :id="item.daichoId"
            :key="index"
            :class="{selected:item.active}"
            class="default"
          >
            <td v-if="item.kknnNo !== null">{{item.uke_no}}</td>
            <td v-if="item.kknnNo !== null">{{item.yoto_naiyo}}</td>
            <td v-if="item.kknnNo !== null">{{item.kknnNo}}</td>
            <td v-if="item.kknnNo !== null">{{dateTextToWareki(item.kknn_day)}}</td>
            <td v-if="item.kknnNo !== null">{{item.timei_tiban}}</td>
            <td v-if="item.kknnNo !== null">{{item.nushi.bldR_NAME_KANJI}}</td>
            <td v-if="item.kknnNo !== null">{{item.refBuilding}} {{item.refOwner}}</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </section>
</template>

<script>
import { dbglog, dateTextToWareki } from '../common/utils'

export default {
  data: () => {
    return {
      headers: [
        {
          text: '受付番号',
          value: 'ukeNo'
        },
        {
          text: '種別',
          value: 'yoto_naiyo'
        },
        {
          text: '確認番号',
          value: 'kknn_no'
        },
        {
          text: '確認年月日',
          value: 'kknn_day'
        },
        {
          text: '所在地',
          value: 'timei_tiban'
        },
        {
          text: '申請者',
          value: 't_nushi'
        },
        {
          text: '関連する建築確認',
          value: 'ref'
        },
      ],
    }
  },
  props: {
  },
  mounted () {
    this.scrollToSelection();
  },
  computed: {
    kenkaku () {
      return this.$store.state.summaries;
    },
  },
  methods: {
    /**
     * 日付の和暦変換
     * @param {Date} date 変換する日付
     * @return {String} 和暦表現に変換された文字列を返す
     */
    dateTextToWareki(date) {
      return dateTextToWareki(date);  // from utils.js
    },
    /**
     * 一覧でクリックされた行を選択
     * @param {GaiyoSummary} target 選択する概要データ
     */
    selectRow (target) {
      dbglog(`ListAddress.selectRow(${target.daichoId})`);
      this.$store.commit('setGaiyoId', target.daichoId);
      this.$store.commit('setKojiId', target.kojiId);
      this.$store.commit('setUkeDay', target.ukeDay);
      this.$store.commit('setUkeNo', target.ukeNo);
      this.$store.commit('setKosakuData', target);
      
      this.kenkaku.forEach((k) => {
        k.active = (k === target);
      });
    },
    /**
     * 選択されている物件がリスト中央に表示されるようにスクロールする
     */
    scrollToSelection () {
      if (this.$store.state.gaiyoId) {
        const tr = document.getElementById(this.$store.state.gaiyoId);
        tr.scrollIntoView({ block: 'center' });
      }
    },
  },  
}
</script>
<style scoped src="@/styles/table-styles.css">
</style>